import {Component, OnInit} from '@angular/core';
import {AuthService} from '../auth.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-login-box',
  templateUrl: './login-box.component.html',
  styleUrls: ['./login-box.component.css']
})
export class LoginBoxComponent implements OnInit {

  constructor(private authService: AuthService,
              private route: Router,) {
  }

  ngOnInit() {
  }

  login(event: any, username: string, password: string) {
    event.preventDefault();
    //console.log("Login: u:" + username + " p:" + password);
    this.authService.loginWithLocalAccount(username, password)
      .subscribe(
        res => {
          //console.log("login res ", res);
          this.route.navigate(['/welcome']);
        },
        err => {
          console.log("login error ", err);
        }
      );
  }

  logout(event:any) {
    event.preventDefault();
    console.log("logout.");
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/login-box/login-box.component.ts